
import React from 'react';

const MissionSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
            理念のハイライト
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-8"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* 左側：ビジョン */}
          <div className="space-y-8">
            <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-alert-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-red-800 mb-3">設立背景</h3>
                  <p className="text-red-700 leading-relaxed">
                    海外から25年間日本を見つめてきた中で、若者の目から生気が失われていく現実に直面。
                    画一的な教育システムが個性を抑制し、学びの意欲を奪っている現状を変えなければならない。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-rocket-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-blue-800 mb-3">目指すゴール</h3>
                  <p className="text-blue-700 leading-relaxed">
                    自分の力で価値を生み出し、経済的に自立し、社会に貢献できる「ネクストリーダー」の育成。
                    従来の教育の枠組みを超える新しい教育スタイル「ネクストスタイル」で日本の未来を変える。
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 右側：画像とメッセージ */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/b9e41f94b8a653c248dde9c3c5ea5cc3/3ab1a48c2f328b707ed3601536e6bdff.jpeg"
                alt="学院長 田中覚弘"
                className="w-full h-96 object-cover object-top"
              />
              <div className="absolute bottom-6 left-6 right-6 text-white">
                <div className="bg-black/60 backdrop-blur-sm rounded-lg p-4">
                  <h4 className="text-xl font-bold mb-2">プリンシパル（学院長）</h4>
                  <p className="text-lg">田中 覚弘</p>
                </div>
              </div>
            </div>
            
            {/* 引用文 */}
            <div className="bg-teal-500 text-white p-6 rounded-lg shadow-xl -mt-8 ml-8 relative z-10">
              <i className="ri-double-quotes-l text-3xl text-teal-200 mb-2"></i>
              <p className="text-lg font-medium italic mb-3">
                「教育を救えるのは、教育だけです。」
              </p>
              <p className="text-sm text-teal-100">
                信念と行動が、世界を変える。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
